module.exports = __webpack_public_path__ + "img/Logotipo Grupo Merca.330bb017.svg";